import React, { ReactNode } from "react";
import { useAuth } from "../store/AuthContext";
import LoginForm from "./LoginForm";

const AuthGate: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { session, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!session) {
    return <LoginForm />;
  }

  return <>{children}</>;
};

export default AuthGate;
